<template>
  <div >
    <div>
      <Tab
        :tabs="tabs"
        :current-tab="currentTab"
        @current-tab="currentTab = $event"
      />
    </div>
    <div v-if="currentTab === 'accounts'">
   <accounts></accounts>
    </div>
    <div v-if="currentTab === 'associations'">
<associations></associations >
    </div>
    <div v-if="currentTab === 'currencyConversion'">
<currency-conversion></currency-conversion >
    </div>

   
  </div>
</template>

<script>
import Tab from "../Tab.vue";
import Accounts from "./Accounts.vue";
import Associations from "./Associations.vue";
import CurrencyConversion from "./CurrencyConversion.vue";
// import Modal from './Modal.vue'


export default {
  components: {
    Tab,
    // InterStateVehicle,
    Accounts,
    Associations,
    CurrencyConversion,
  
  },
  data() {
    return {
      estimatedCost:30000,
      selected: [],
      allSelected: false,
      indeterminate: false,
      item: false,
      showModal: false,
      showRoutes: false,
      viewAllRoutes: false,
shipmentPackages:['light', 'heavy', 'haulage'],
      routes: [
        "Lagos - Abuja",
        "Lagos - Enugu",
        "Lagos - Ibadan",
        "Lagos - Kano",
      ],
      tabs: [
        { id: "accounts", value: "Accounts" },
        { id: "associations", value: "Associations" },
        { id: "currencyConversion", value: "Currency Conversion" }
      ],
      currentTab: "accounts",
    };
  },
  methods: {
    toggleAll(checked) {
      this.selected = checked ? this.routes.slice() : [];
    },
  },
  watch: {
    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.routes.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style scoped>
.estimateBox{
  border: 1px solid #DAE8F6; border-radius: 2px; width: 207px; height: 44px; font-size:24px; font-weight: 600;
 margin-top: -10px;
  padding: 5.5px 10px 5.5px 80px ;
}
</style>
